export default class AmenitiesGroup {
    static levels = [
        {
            value: 'standard',
            label: 'Standard Amenity'
        },
        {
            value: 'open',
            label: 'Open Amenity'
        }
    ]

    static label(value) {
        return AmenitiesGroup.levels.find(level => level.value === value)?.label;
    }
}